import React from "react";
import { Table, Button, Card, Row, Col, Alert } from "antd";

const columnsKemasan = [
    { title: "Seri", dataIndex: "seri", key: "seri" },
    { title: "Jumlah", dataIndex: "jumlah", key: "jumlah" },
    { title: "Jenis", dataIndex: "jenis", key: "jenis" },
    { title: "Merek", dataIndex: "merek", key: "merek" },
];

const columnsPetiKemas = [
    { title: "Seri", dataIndex: "seri", key: "seri" },
    { title: "Nomor", dataIndex: "nomor", key: "nomor" },
    { title: "Ukuran", dataIndex: "ukuran", key: "ukuran" },
    { title: "Jenis Muatan", dataIndex: "jenisMuatan", key: "jenisMuatan" },
    { title: "Tipe", dataIndex: "tipe", key: "tipe" },
];

const Kemasan = ({ data, setData }) => {
    return (
        <div>
            <Alert
                message="Wajib mengisi data kemasan"
                type="warning"
                showIcon
                style={{ marginBottom: 20 }}
            />
            <Row gutter={24}>
                <Col span={12}>
                    <Card title="Kemasan" extra={<Button type="primary">Tambah</Button>}>
                        <Table columns={columnsKemasan} dataSource={[]} pagination={false} />
                    </Card>
                </Col>
                <Col span={12}>
                    <Card title="Peti Kemas" extra={<Button type="primary">Tambah</Button>}>
                        <Table columns={columnsPetiKemas} dataSource={[]} pagination={false} />
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Kemasan;
